export const bakery = `Bread
Sandwhich Bread
Rolls
Hamburger Buns
Burger Buns
Hotdog Buns`;
